import React from "react";
import { Link } from "react-router-dom";
import { Api } from "../app-controller.js";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import AcceptForm from "../components/product-movements/AcceptForm";
import InfoForm from "../components/product-movements/InfoForm";
import classnames from "classnames";
import Swal from "sweetalert2";

class ProductMovementsIncome extends React.Component {
  initialState = {
    previa: false,
    previa_url: "",
    modalState: false,
    modalInfoState: false,
    working: true,
    workingModal: true,
    toggle: false,
    paginaActual: 0,
    bitacora_producto: "",
    paginaActual_vi: 0,
    paginas: 0,
    paginas_vi: 0,
    registros: 0,
    registros_vi: 0,
    solicitudes: [],
    activeTab: "1",
    nivelUsuario: localStorage.nivel_actual,
    buscar: {},
    cat_actividad: Api.loadCatalogue("cat_actividad"),
    cantidades_lotes: [],
    observaciones: "",
    collapse: [
      {
        id: 1,
        collapse: true,
      },
      {
        id: 2,
        collapse: false,
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  toggleCollapse = (index) => {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  };

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });
    this.getProductMovementExitList(1);
  }

  // Inicia logica que controla la pestaña de regente (grid y detalle)
  search = [];

  handleSearch = (evt) => {
    // Si el obj.target.name pertenece a un input type text aplicamos la funcion toUpperCase()
    [
      "folio_movimiento",
      "establecimiento_envia",
      "establecimiento_recibe",
      "fecha_solicitud",
      "fecha_vencimiento",
    ].includes(evt.target.name)
      ? (this.search[evt.target.name] = evt.target.value.toUpperCase())
      : (this.search[evt.target.name] = evt.target.value);

    this.setState({ buscar: this.search });
  };

  // cleanSearch = () => {
  //   let search = this.state.buscar;

  //   for (const prop in search) {
  //     delete search[prop];
  //     document.getElementById(prop).value = "";
  //   }

  //   this.setState({ buscar: search });
  //   this.getProductMovementExitList(1);
  // };

  //Funcion para cambiar de pagina en el grid de regente
  getProductMovementExitList = (page) => {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getProductMovementExitList?page=" + page + src).then(
      (sol) => {
        this.setState({
          solicitudes: sol.data,
          paginas: sol.last_page,
          registros: sol.total,
          paginaActual: sol.current_page,
          workingGrid: false,
        });
      }
    );
  };

  validateSingleError = (el, msg) => {
    document.getElementById(el + "-error").style.display = "block";
    document.getElementById(el + "-error").innerText = msg;
    document.getElementById(el).classList.add("is-invalid");
  };

  handleListaMovimientosProducutosPage = (e) => {
    this.getProductMovementExitList(e.target.value);
  };

  handleModalCloseBtn = (evt) => {
    evt.preventDefault();

    this.setState({
      workingModal: true,
      bitacora_producto: "",
      modalState: false,
      modalInfoState: false,
    });
  };

  openModalForm = (evt) => {
    this.setState({ modalState: true });
    //buscamos la bitacora de movimiento
    Api.fetch(
      "app/getBitacoraProductoIngreso?bitacora_movimiento_id=" + evt.target.id
    )
      .then((data) => {
        if (data) {
          let cantidades_lotes = this.state.cantidades_lotes;
          data.rel_bitacora_producto_lote.forEach((d) => {
            cantidades_lotes.push(d);
          });

          this.setState({
            bitacora_producto: data,
            cantidades_lotes: cantidades_lotes,
          });
        }
      })
      .then((res) => {
        this.setState({ workingModal: false });
      });
  };

  openModalInfoForm = (evt) => {
    this.setState({ modalInfoState: true });
    //buscamos la bitacora de movimiento
    Api.fetch(
      "app/getBitacoraMovimiento?id=" +
        evt.target.id +
        "&ver_movimiento_completo=" +
        1
    )
      .then((data) => {
        if (data) {
          this.setState({
            bitacora_movimiento: data,
          });
        }
      })
      .then((res) => {
        this.setState({ workingModal: false });
      });
  };

  handleSubmit = (evt) => {
    evt.preventDefault();

    let movementData = {
      ...this.state,
    };

    delete movementData.collapse;
    delete movementData.activeTab;
    delete movementData.buscar;
    delete movementData.modalState;
    delete movementData.modalInfoState;
    delete movementData.nivelUsuario;
    delete movementData.paginaActual;
    delete movementData.paginaActual_vi;
    delete movementData.paginas;
    delete movementData.paginas_vi;
    delete movementData.previa_url;
    delete movementData.registros;
    delete movementData.registros_vi;
    delete movementData.toggle;
    delete movementData.working;
    delete movementData.workingGrid;
    delete movementData.workingModal;
    delete movementData.previa;
    delete movementData.solicitudes;
    delete movementData.cat_actividad;

    // este foreach es para validar y mandar mensajes de error a un input en especifico de la lista
    movementData.cantidades_lotes.forEach((obj, index) => {
      // si cantidad_aceptada es null
      if (!obj.cantidad_aceptada) {
        this.validateSingleError(
          `cantidad_lote-${index}`,
          "Ingrese cantidad a aceptar."
        );
      }

      // si cantidad_acepta_valida es false
      if (!obj.cantidad_aceptada_valida && obj.cantidad_aceptada) {
        this.validateSingleError(
          `cantidad_lote-${index}`,
          "La cantidad ingresada es mayor a la recibida."
        );
      }
    });

    // buscamos en cada lote si la cantidad aceptada es null
    let cantidadesVacias = movementData.cantidades_lotes.some(
      (obj) => !obj.cantidad_aceptada
    );

    // buscamos en cada lote si cantidad aceptada valida es false
    let cantidadesAceptadasValidas = movementData.cantidades_lotes.some(
      (obj) => !obj.cantidad_aceptada_valida
    );

    // buscamos si el usuario puso en todos los lotes 0, ya que esto nos quiere decir que se rechazó
    let todasCanttidadesEnCero = movementData.cantidades_lotes.some(
      (obj) => obj.cantidad_aceptada !== "0"
    );

    // si alguno de los dos es false no podemos hacer submit hasta que se corrijan esos errores
    if (!cantidadesVacias && !cantidadesAceptadasValidas) {
      // si todos los lotes estan con cantidad aceptada = 0 entonces significa que se rechazaron todos por lo tanto se debe especificar el motivo de rechazo
      if (!todasCanttidadesEnCero && !movementData.observaciones) {
        this.validateSingleError("observaciones", "Ingrese motivo de rechazo.");
      } else {
        // preguntamos si el usuario esta seguro de la decision tomada respecto a los producto aceptados y rechazados
        Swal.fire({
          icon: "question",
          title: "¿Completar transacción?",
          text: "¡Asegúrese que los datos estén completados correctamente!",
          showDenyButton: true,
          denyButtonColor: "red",
          confirmButtonColor: "#4CD964",
          showCancelButton: false,
          confirmButtonText: `Continuar`,
          denyButtonText: `Regresar`,
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitForm(movementData);
          }
        });
      }
    }
  };

  submitForm = (movementData) => {
    Api.loading(true);
    Api.fetch("app/updateProductsMovementIncome", movementData, "PUT").then(
      (data) => {
        if (data) {
          Api.loading(false);
          Swal.fire({
            icon: "success",
            title:
              "¡El proceso de ingreso de producto ha sido completado exitosamente!",
            timer: 3000,
            confirmButtonText: "Continuar",
          }).then(() => {
            window.location.href = "/movimientos-productos/ingresos";
          });
          this.resetStates();
        }
      }
    );
  };

  // fn para reiniciar todos los estados una vez el submit sea éxitoso
  resetStates = () => {
    this.setState({
      bitacora_producto: this.initialState.bitacora_producto,
      cantidades_lotes: [],
      observaciones: this.initialState.observaciones,
    });
  };

  // fn para marcar los campos que duevelen error desde la api
  handleValidations = (errors) => {
    for (const i in errors) {
      document.getElementById(i + "-error").style.display = "block";
      document.getElementById(i + "-error").innerText = errors[i];
      document.getElementById(i).classList.add("is-invalid");
    }
  };

  handleObservationChange = (evt) => {
    this.cleanErrorsValidation("observaciones");
    this.setState({ observaciones: evt.target.value.toUpperCase() });
  };

  // fn para depslegar mensajes de alerta sencillos
  fireSwal(title, icon = "error") {
    Swal.fire({
      title: title,
      icon: icon,
      timer: 5000,
      confirmButtonText: "Regresar",
    });
    return false;
  }

  rejectedAll = (evt) => {
    evt.preventDefault();
    Swal.fire({
      icon: "question",
      title: "Rechazar todo",
      text: "¿Está seguro de rechazar todos los productos enviados?",
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      showCancelButton: false,
      confirmButtonText: `Continuar`,
      denyButtonText: `Regresar`,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Ingrese motivo de rechazo",
          input: "textarea",
          inputAttributes: {
            style: "text-transform: uppercase",
            required: true,
            title: "Ingrese motivo de rechazo",
          },
          inputValue: this.state.observaciones,
          confirmButtonText: "Continuar",
          showCancelButton: true,
          cancelButtonText: "Regresar",
          cancelButtonColor: "#0275d8",
          confirmButtonColor: "#4CD964",
          reverseButtons: true,
        }).then((result) => {
          let observaciones = "";

          if (result.value) {
            observaciones = result.value.toUpperCase();
          }
          this.setState({ observaciones: observaciones });

          if (result.isConfirmed) {
            let movementData = {
              ...this.state,
            };

            delete movementData.collapse;
            delete movementData.activeTab;
            delete movementData.buscar;
            delete movementData.modalState;
            delete movementData.modalInfoState;
            delete movementData.nivelUsuario;
            delete movementData.paginaActual;
            delete movementData.paginaActual_vi;
            delete movementData.paginas;
            delete movementData.paginas_vi;
            delete movementData.previa_url;
            delete movementData.registros;
            delete movementData.registros_vi;
            delete movementData.toggle;
            delete movementData.working;
            delete movementData.workingGrid;
            delete movementData.workingModal;
            delete movementData.previa;
            delete movementData.solicitudes;

            Api.loading(true);
            Api.fetch("app/rejectedAll", movementData, "PUT").then((data) => {
              if (data) {
                Api.loading(false);
                Swal.fire({
                  icon: "success",
                  title: "¡El producto ha sido rechazado exitosamente!",
                  timer: 3000,
                  confirmButtonText: "Continuar",
                }).then(() => {
                  window.location.href = "/movimientos-productos/ingresos";
                });
                this.resetStates();
              }
            });
          }
        });
      }
    });
  };

  handleCantidadLoteInput = (evt) => {
    this.cleanErrorsValidation("observaciones");

    let index = evt.target.name.split("-")[1],
      cantidadesLotes = this.state.cantidades_lotes,
      inputValue = evt.target.value,
      targetName = evt.target.name;

    // validamos mediante regex que el valor ingresado en el input sea numero entero positivo
    if (this.checkPositiveIntegersWithZero(inputValue)) {
      // si lo es, validamos que la cantidad aceptada no sea mayor que la enviada
      if (
        parseInt(cantidadesLotes[index].cantidad_enviada) < parseInt(inputValue)
      ) {
        this.validateSingleError(
          targetName,
          `Este lote solo cuenta con ${cantidadesLotes[index].cantidad_enviada} existencias.`
        );
        cantidadesLotes[index].cantidad_aceptada_valida = false;
      } else {
        this.cleanErrorsValidation(targetName);
        cantidadesLotes[index].cantidad_aceptada_valida = true;
      }

      cantidadesLotes[index].cantidad_aceptada = inputValue;

      this.setState({
        cantidades_lotes: cantidadesLotes,
      });
    }
  };

  /*********** Funciones ***********/

  // funcion para validar solo enteros positivos en un input
  checkPositiveIntegersWithZero = (str) => {
    let regex = /^(0|[1-9]\d{0,6})$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  handlePrevia = (e) => {
    let doc = e.target.getAttribute("data-file");
    this.setState({ previa: true, previa_url: doc });
  };

  // fn para limpar errores cuando cambie el estado del input que los tenga
  cleanErrorsValidation = (elemento) => {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  };

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/movimientos-productos/ingresos">
              Movimiento productos
            </Link>
          </li>
          <li className="breadcrumb-item">Ingresos</li>
        </ol>
        <h1 className="page-header">Ingreso productos</h1>
        <div className="row">
          <div className="col-xl-12">
            <Nav tabs={true}>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggleTab("1");
                  }}
                >
                  <span className="d-sm-none">
                    INGRESOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    INGRESOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <div className="table-responsive">
                  <fieldset>
                    <legend>Buscar</legend>

                    <div className="row">
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="establecimiento_envia">
                            Establecimiento envía:
                          </label>
                          <div className="form-group">
                            <input
                              id="establecimiento_envia"
                              name="establecimiento_envia"
                              onChange={this.handleSearch}
                              placeholder="Ingrese establecimiento"
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="actividad_envia">
                            Actividad envía:
                          </label>
                          <select
                            name="actividad_envia"
                            id="actividad_envia"
                            className="form-control"
                            onChange={this.handleSearch}
                            placeholder="Ingrese actividad"
                          >
                            <option value="">Seleccione actividad</option>
                            {this.state.cat_actividad.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.descripcion.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="establecimiento_recibe">
                            Establecimiento recibe:
                          </label>
                          <input
                            id="establecimiento_recibe"
                            name="establecimiento_recibe"
                            onChange={this.handleSearch}
                            placeholder="Ingrese establecimiento"
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="actividad_recibe">
                            Actividad recibe:
                          </label>
                          <select
                            name="actividad_recibe"
                            id="actividad_recibe"
                            className="form-control"
                            onChange={this.handleSearch}
                            placeholder="Ingrese actividad"
                          >
                            <option value="">Seleccione actividad</option>
                            {this.state.cat_actividad.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.descripcion.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="folio_movimiento">
                            Folio movimiento:
                          </label>
                          <input
                            id="folio_movimiento"
                            name="folio_movimiento"
                            placeholder="Ingrese folio"
                            onChange={this.handleSearch}
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="estatus">Estado:</label>
                          <select
                            name="estatus"
                            id="estatus"
                            className="form-control"
                            onChange={this.handleSearch}
                          >
                            <option value="">Seleccione estatus</option>
                            <option value="5">ACEPTADA</option>
                            <option value="9">EN ESPERA SINAIP</option>
                            <option value="4">RECHAZADA</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="fecha_solicitud">
                            Fecha de solicitud:
                          </label>
                          <input
                            type="date"
                            name="fecha_solicitud"
                            onChange={this.handleSearch}
                            id="fecha_solicitud"
                            className="form-control"
                            placeholder="Fecha"
                          />
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="search">&nbsp;</label>
                          <button
                            type="button"
                            className="btn btn-orange w-100"
                            title="Buscar"
                            onClick={() => this.getProductMovementExitList(1)}
                          >
                            <i className="fa fa-search"></i> Buscar
                          </button>
                        </div>
                      </div>

                      {/* <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="search">&nbsp;</label>
                          <div className="input-group">
                            <button
                              type="button"
                              className="btn btn-blue w-100"
                              title="Limpiar"
                              onClick={this.cleanSearch}
                            >
                              <i className="fas fa-trash-alt"></i> Limpiar
                            </button>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </fieldset>

                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">FOLIO MOVIMIENTOS</th>
                        <th className="text-center">ESTABLECIMIENTO ENVÍA</th>
                        <th className="text-center">ACTIVIDAD ENVÍA</th>
                        <th className="text-center">ESTABLECIMIENTO RECIBE</th>
                        <th className="text-center">ACTIVIDAD RECIBE</th>
                        <th className="text-center">FECHA SOLICITUD</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center">FECHA RESPUESTA</th>
                        <th className="text-center"></th>
                      </tr>
                    </thead>
                    <tbody className={this.state.workingGrid ? "hide" : ""}>
                      {this.state.solicitudes &&
                      this.state.solicitudes.length > 0 ? (
                        this.state.solicitudes.map((sol) => (
                          <tr key={sol.id}>
                            <td className="text-center">
                              {sol.folio_movimiento}
                            </td>
                            <td className="text-center">
                              {sol.establecimiento_envia_nombre}
                            </td>
                            <td className="text-center">
                              {sol.actividad_envia["descripcion"]}
                            </td>
                            <td className="text-center">
                              {sol.establecimiento_recibe_nombre}
                            </td>
                            <td className="text-center">
                              {sol.actividad_recibe["descripcion"]}
                            </td>
                            <td className="text-center">
                              {sol.fecha_solicitada}
                            </td>
                            <td className="text-center">{sol.tramite}</td>
                            <td className="text-center">
                              {sol.fecha_respuesta
                                ? sol.fecha_respuesta
                                    .substr(0, 10)
                                    .split("-")
                                    .reverse()
                                    .join("/")
                                : "N/A"}
                            </td>
                            <td className="text-center">
                              {!sol.formulario_acepta ? (
                                <div className="btn-group">
                                  <button
                                    onClick={this.openModalForm}
                                    id={sol.id}
                                    title="LLenar formulario para movimiento de productos"
                                    className="btn bg-gradient-green"
                                  >
                                    <i id={sol.id} className="fas fa-list"></i>
                                  </button>
                                </div>
                              ) : (
                                <div className="btn-group">
                                  <button
                                    onClick={this.openModalInfoForm}
                                    id={sol.id}
                                    title="Ver información del movimiento"
                                    className="btn bg-gradient-blue"
                                  >
                                    <i id={sol.id} className="fas fa-eye"></i>
                                  </button>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No se encontraron resultados
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.getProductMovementExitList(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual - 1 > 0) {
                              this.getProductMovementExitList(
                                this.state.paginaActual - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual} de {this.state.paginas}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas >=
                              this.state.paginaActual + 1
                            ) {
                              this.getProductMovementExitList(
                                this.state.paginaActual + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.getProductMovementExitList(this.state.paginas);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.handleListaMovimientosProducutosPage}
                        type="number"
                        min="1"
                        max={this.state.paginas}
                        value={this.state.paginaActual}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>
          <Modal
            isOpen={this.state.modalState}
            tabIndex="-1"
            style={{
              maxWidth: "100%",
              width: "75%",
            }}
          >
            <ModalHeader
              width="100%"
              toggle={() => {
                this.setState({
                  modalState: false,
                  workingModal: true,
                  bitacora_producto: "",
                });
                this.resetStates();
              }}
              className="text-center"
            >
              DATOS DE RECEPCIÓN DE PRODUCTO
            </ModalHeader>
            <ModalBody>
              <form onSubmit={this.handleSubmit} id="accept-form">
                <AcceptForm
                  state={this.state}
                  workingModal={this.state.workingModal}
                  handleCantidadLoteInput={this.handleCantidadLoteInput}
                  rejectedAll={this.rejectedAll}
                  handleObservationChange={this.handleObservationChange}
                />
              </form>
            </ModalBody>
            {/* <ModalFooter>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <button
                        onClick={this.handleModalCloseBtn}
                        className="btn btn-danger float-right"
                      >
                        Regresar
                      </button>
                    </div>
                  </div>
                </div>
              </ModalFooter> */}
          </Modal>

          <Modal
            isOpen={this.state.modalInfoState}
            tabIndex="-1"
            style={{
              maxWidth: "100%",
              width: "80%",
            }}
          >
            <ModalHeader
              width="100%"
              toggle={() => {
                this.setState({
                  modalInfoState: false,
                  workingModal: true,
                  bitacora_movimiento: "",
                });
                this.resetStates();
              }}
              className="text-center"
            >
              {this.state.bitacora_movimiento
                ? `Folio: ${this.state.bitacora_movimiento.folio_movimiento}`
                : null}
            </ModalHeader>
            <ModalBody>
              <InfoForm
                bitacora_movimiento={this.state.bitacora_movimiento}
                workingModal={this.state.workingModal}
                handlePrevia={this.handlePrevia}
              />
            </ModalBody>
            {/* <ModalFooter>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <button
                        onClick={this.handleModalCloseBtn}
                        className="btn btn-daanger float-right"
                      >
                        Regresar
                      </button>
                    </div>
                  </div>
                </div>
              </ModalFooter> */}
          </Modal>
          <div className={this.state.previa ? "previa" : "hide"}>
            <iframe
              title="Vista previa"
              className="rounded"
              src={this.state.previa_url}
            ></iframe>
            <center>
              <div className="btn-group">
                <button
                  onClick={() => {
                    this.setState({
                      previa: this.initialState.previa,
                      previa_url: this.initialState.previa_url,
                    });
                  }}
                  className="btn btn-danger"
                >
                  Regresar
                </button>
                <a
                  className="btn btn-primary"
                  href={this.state.previa_url + "&download=1"}
                  download="download"
                >
                  Descargar
                </a>
              </div>
            </center>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductMovementsIncome;
